export const GridSystem  = [{
    label:'column 1',
    value:['100%']
},{
    label:'column 2',
    value:['50%','50%']
    //value:['100%','100%']
},{
    label:'column 3',
    value:['33.33%','33.33%','33.34%']
    //value:['100%','100%','100%']
},
{
    label:'column 4',
    value:['25%','25%','25%','25%']
    //value:['100%','100%','100%','100%']
}];



export const HeadingTypes  = [{
    label:'H1',
    value:'h1'
},{
    label:'H2',
    value:'h2'
},{
    label:'H3',
    value:'h3'
},{
    label:'H4',
    value:'h4'
},{
    label:'H5',
    value:'h5'
},{
    label:'H6',
    value:'h6'
}];


export const AlignmentTypes  = [{
    label:'H1',
    value:'left'
},{
    label:'H2',
    value:'center'
},{
    label:'H3',
    value:'right'
},{
    label:'H4',
    value:'justify'
}];

export const FontWeightTypes  = [{
    label:'Regular',
    value:'normal'
},{
    label:'Bold',
    value:'bold'
}];

export const FontFamilyTypes  = [{
    label:'Arial',
    value:"'Arial', sans-serif"
},{
    label:'Helvitca',
    value:"'Helvitca', sans-serif"
},{
    label:'Courier New',
    value:"'Courier New', sans-serif"
},{
    label:'Calibri',
    value:"'Calibri', sans-serif"
}];


export const FontStyleTypes  = [{
    label:'Regular',
    value:'normal'
},{
    label:'Italic',
    value:'italic'
},{
    label:'Oblique',
    value:'oblique'
}];

export const LinkTargetTypes  = [{
    label:'Blank',
    value:'_blank'
},{
    label:'Self',
    value:'_self'
}];

export const BorderLineTypes  = [
    {
        label:'Solid',
        value:'solid'
    },
    {
        label:'Dashed',
        value:'dashed'
    },
    {
        label:'Dotted',
        value:'dotted'
    }
];

export const PaperSizeTypes  = [
    {
        label:'Full',
        value:'100%'
    },
    {
        label:'A4 [W=800]',
        value:'800px'
    },{
        label:'A1 [W=600]',
        value:'600px'
    }
];

export const StyleAttributesOriginal = {
    color:'color',
    backgroundColor:'background-color',
    contentAlign:'content-align',
    fontFamily:'font-family',
    fontWeight:'font-weight',
    padding:'padding',
    backgroundColor:'background-color',
    textAlign:'text-align',
    fontSize:'font-size',
    fontStyle:'font-style',
    src:'src',
    dimension:'dimension',
    href:'href',
    borderTop:'border-top',
    borderBottom:'border-bottom',
    borderLeft:'border-left',
    borderRight:'border-right',
    border:'border' 
}



